import "./Header.scss";
import { toggleNavOrgMgt, toggleNav } from "../../../static/js/commons";
import translate from "@/i18n/translate";
import { useIntl } from "react-intl";
const { REDIRECT_URI } = runConfig;
import { Institution } from "../interfaces/Interface";

export interface MainSideNavBarProps {
  institution: Institution;
  collapseSideNav: boolean;
}
export default function MainSideNavBar({
  institution,
  collapseSideNav
}: MainSideNavBarProps): JSX.Element {
  const hide_sideNav_class = (collapseSideNav: boolean) => {
    return !collapseSideNav ? "hamburger-hide" : "";
  };

  const toggle_nav = (collapseSideNav: boolean) => {
    return !collapseSideNav ? toggleNavOrgMgt : toggleNav;
  };

  const useMainSideNavBar = () => {
    const strategicPlan = useIntl().formatMessage({
      id: "app.mainnav.strategicPlans"
    });

    const programReview = useIntl().formatMessage({
      id: "app.mainnav.programReview"
    });
    const accreditation = useIntl().formatMessage({
      id: "app.mainnav.accreditation"
    });

    const render_program_review = () => {
      if (institution.showProgramReview) {
        return (
          <li className="menuitem">
            <a
              href={`${REDIRECT_URI}/program-review`}
              id="nav-program-review"
              className="navlink nav-links"
            >
              <span>
                <img src="/images/program-review.svg" alt={programReview} />
              </span>
              <span id="program-reviewtext" className="menuname">
                {translate("app.mainnav.programReview")}{" "}
              </span>
            </a>
          </li>
        );
      }
    };
    return (
      <nav
        id="mainnav"
        className={`main-nav main-nvs items-9 ${hide_sideNav_class(
          collapseSideNav
        )}`}
      >
        <div id="nav-start-div" className="navwrapper"></div>
        <button
          id="nav-toggle"
          className="icononly show-nav-toggle"
          onClick={toggle_nav(collapseSideNav)}
        >
          <span className="sr-only tooltip -bottom -multiline">
            {translate("app.hideNavigation")}
          </span>
          <span className="hamburger-inner"></span>
        </button>

        <ul id="navmenu" className={`menu org-profile-menu`}>
          {/* Use "active-parent" class for li tag, based on which side nav option is selected, example given below */}
          <li className="menuitem active-parent">
            {/* Use "active" class for a tag, based on which side nav option is selected, example given below*/}
            <a
              href={REDIRECT_URI}
              id="nav-home"
              className="navlink nav-links active"
            >
              <span className="icon pe-va pe-fw pe-7s-home"></span>
              <span id="hometext" className="menuname">
                {translate("app.mainnav.home")}
              </span>
            </a>
          </li>
          <li className="menuitem">
            <a
              href={`${REDIRECT_URI}/school-org`}
              id="toolsNavItemLink"
              className="navlink nav-links"
            >
              <span className="icon pe-va pe-fw pe-7s-notebook"></span>
              <span id="orgtext" className="menuname">
                {translate("app.mainnav.organizationManagement")}
              </span>
            </a>
          </li>
          <li className="menuitem">
            <a
              href={`${REDIRECT_URI}/plan`}
              id="nav-plans"
              className="navlink nav-links"
            >
              <span className="icon pe-va pe-fw pe-7s-folder"></span>
              <span id="plantext" className="menuname">
                {translate("app.mainnav.plans")}
              </span>
            </a>
          </li>
          <li className="menuitem">
            <a
              href={`${REDIRECT_URI}/self-studies`}
              id="nav-accreditationselfstudies"
              className="navlink nav-links"
            >
              <span className="selfstudy-icon">
                <img
                  src="/images/accreditation_self_studies.svg"
                  alt={accreditation}
                />
              </span>
              <span id="selfstudytext" className="menuname">
                {translate("app.mainnav.accreditation")}
              </span>
            </a>
          </li>
          {render_program_review()}
          <li className="menuitem">
            <a
              href={`${REDIRECT_URI}/strategic_plan`}
              id="nav-sp"
              className="navlink nav-links"
            >
              <span>
                <img src="/images/strategic-plan.svg" alt={strategicPlan} />
              </span>
              <span id="strategic-planning" className="menuname">
                {translate("app.mainnav.strategicPlans")}
              </span>
            </a>
          </li>
          <li className="menuitem">
            <a
              href={`${REDIRECT_URI}/admin`}
              id="nav-admin"
              className="navlink nav-links"
            >
              <span className="icon pe-va pe-fw pe-7s-config"></span>
              <span id="admintext" className="menuname">
                {translate("app.mainnav.admin")}
              </span>
            </a>
          </li>
        </ul>
        <div className="wmrklogo">
          <img src="/images/watermarklogo.svg" alt="Watermark"></img>
        </div>
        <div id="nav-end-div" className="navwrapper" tabIndex={0}></div>
      </nav>
    );
  };

  return <>{useMainSideNavBar()}</>;
}
